
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/venda-direta/frotista",
      function () {
        return require("private-next-pages/venda-direta/frotista.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/venda-direta/frotista"])
      });
    }
  